import { registerDynamicListToolbarExtension } from "@/utils/dynamicListToolbarRegistry";

registerDynamicListToolbarExtension({
  requiresModule: "findTeu_module",
  component: () =>
    import("@/components/findTeu/FindTeuBulkStartTrackingToolbar.vue"),
});
